package org.zest.insan_360_website.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.zest.insan_360_website.components.widgets.LanguageToggle
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.ResultPageState.hasSubmitted


val resultWordLibrary = LanguageSettings.ResultPage

@Composable
@Layout
fun ResultPageLayout(ctx: PageContext, content: @Composable () -> Unit) {

    LaunchedEffect(Unit) {
        AuthState.load()
        if (!AuthState.isLoggedIn) ctx.router.navigateTo("/?needToLogin=true")
    }

    Box(
        modifier = Modifier
            .backgroundColor(userPageBGColor)
            .minHeight(100.dvh)
            .fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        LanguageToggle(rightEm = 1.5, topEm = 1.5)
        content()
        if (hasSubmitted) {
            Button(
                onClick = {
                    ctx.router.navigateTo("/user")
                },
                modifier = Modifier
                    .position(Position.Absolute)
                    .left(50.percent)
                    .translate(tx = (-50).percent, ty = 0.px)
                    .bottom(2.cssRem)
            ) {
                SpanText(LanguageSettings.ResultPage.back_home.localized)
            }
        }
    }
}